import "../styles.scss";

const NotFound = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8552 1.96256C11.8497 1.95643 11.8445 1.95011 11.8386 1.94424C11.826 1.9316 11.8127 1.91992 11.799 1.909C10.545 0.726209 8.85584 0 7.0001 0C3.14025 0 0 3.14025 0 7.00026C0.000127666 8.85513 0.725715 10.5435 1.90758 11.7973C1.91888 11.8116 1.93088 11.8255 1.94409 11.8386C1.95092 11.8454 1.95813 11.8514 1.96522 11.8577C3.23913 13.1777 5.02536 14 7.00016 14C10.8599 14 14 10.8599 14 7.00019C13.9999 5.02397 13.1766 3.23663 11.8552 1.96256ZM7.0001 0.95747C8.43876 0.95747 9.76125 1.46321 10.8001 2.30578L2.30577 10.7999C1.4633 9.76115 0.95762 8.43869 0.957492 7.00019C0.957492 3.66826 3.66822 0.95747 7.0001 0.95747ZM7.0001 13.0425C5.45094 13.0425 4.03621 12.4562 2.96561 11.4941L11.4943 2.96567C12.4563 4.03625 13.0424 5.451 13.0424 7.00019C13.0424 10.3319 10.3318 13.0425 7.0001 13.0425Z"
        fill="#CB2B2B"
      />
    </svg>
  );
};

export const RoundCircle = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.36576 12.825C12.0903 12.825 14.2989 10.6256 14.2989 7.91251C14.2989 5.1994 12.0903 3 9.36576 3C6.64126 3 4.43262 5.1994 4.43262 7.91251C4.43262 10.6256 6.64126 12.825 9.36576 12.825Z"
        fill="#BFD8F9"
      />
      <path
        d="M10.7043 7.11545L8.80143 9.01824L7.98942 8.20623C7.83544 8.05231 7.5858 8.05231 7.43188 8.20623C7.27791 8.36025 7.27791 8.60984 7.43188 8.76381L8.52266 9.85459C8.59962 9.93155 8.70055 9.97003 8.80143 9.97003C8.9023 9.97003 9.00323 9.93155 9.08019 9.85459L11.2618 7.67304C11.4158 7.51907 11.4158 7.26942 11.2619 7.1155C11.1079 6.96153 10.8583 6.96148 10.7043 7.11545Z"
        fill="#0E0E0E"
      />
      <path
        d="M17.4698 5.56883C17.3082 5.47764 17.1032 5.53485 17.012 5.69658L16.7969 6.07822C16.3796 4.49177 15.4932 3.05576 14.2503 1.97316C12.7889 0.700426 10.925 0 8.99974 0H8.98808C7.07424 0.00278961 5.2171 0.698107 3.75881 1.9578C2.3187 3.2018 1.34661 4.92221 1.02157 6.80217C0.989944 6.98507 1.11259 7.159 1.29546 7.19063C1.47863 7.22205 1.65229 7.09961 1.68392 6.91674C2.30862 3.3037 5.38088 0.677505 8.98909 0.672228H9.00015C12.4146 0.672228 15.322 2.99402 16.1583 6.28851L15.749 6.05086C15.5885 5.95769 15.3828 6.01227 15.2896 6.17279C15.1964 6.33331 15.251 6.539 15.4115 6.6322L16.507 7.26823C16.5587 7.29828 16.617 7.31367 16.6758 7.31367C16.7054 7.31367 16.7351 7.30978 16.7641 7.30188C16.8508 7.27825 16.9244 7.22091 16.9686 7.1426L17.5976 6.02669C17.6887 5.86493 17.6315 5.65994 17.4698 5.56883Z"
        fill="#0E0E0E"
      />
      <path
        d="M16.7781 8.80856C16.5947 8.77683 16.4212 8.89958 16.3896 9.08245C15.7649 12.6955 12.6927 15.3217 9.08445 15.327H9.07339C5.65898 15.327 2.75157 13.0052 1.91523 9.71068L2.32456 9.94833C2.48508 10.0415 2.69077 9.98692 2.78397 9.8264C2.87714 9.66588 2.82256 9.46019 2.66204 9.36699L1.56649 8.73096C1.48879 8.68582 1.39619 8.67378 1.30951 8.69731C1.22277 8.72094 1.14913 8.77828 1.105 8.85659L0.475994 9.97253C0.384844 10.1342 0.442014 10.3392 0.603744 10.4303C0.655906 10.4597 0.712539 10.4737 0.768465 10.4737C0.88583 10.4737 0.999801 10.4121 1.06154 10.3026L1.27668 9.92094C1.69398 11.5074 2.58033 12.9434 3.82332 14.026C5.28464 15.2987 7.1486 15.9992 9.07383 15.9992H9.08549C10.9993 15.9964 12.8565 15.301 14.3148 14.0414C15.7549 12.7974 16.727 11.0769 17.052 9.19699C17.0836 9.01412 16.961 8.84019 16.7781 8.80856Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

const KeyFeaturesAndTag = ({ searchedStringBE, showDomainInfo }) => {
  return (
    <div className="features__tags">
      {showDomainInfo && (
        <div className="tags__domain-taken">
          <NotFound />
          <span className="tags__domain-taken-text">{searchedStringBE} is already taken</span>
        </div>
      )}
      <div className="features__segment">
        <span className="features__segment--desc">Every domain includes:</span>
        <div className="features__segment--content">
          <RoundCircle />
          <span className="features__segment--content-text">Free web hosting</span>
        </div>
        <div className="features__segment--content">
          <RoundCircle />
          <span className="features__segment--content-text">Free SSL Certificate</span>
        </div>
      </div>
    </div>
  );
};

export default KeyFeaturesAndTag;
